import type { PayloadAction } from '@reduxjs/toolkit';

import { buildCreateSlice } from '@reduxjs/toolkit';

import { MOBILE_BREAKPOINT, TABLET_BREAKPOINT } from '@shared/constants/global';

import { ScreenSizeTrackingStateType } from '../types/screenSizeTrackingState';

const createAppSlice = buildCreateSlice();

const initialState: ScreenSizeTrackingStateType = {
  width: 0,
  height: 0,
  viewPort: 'desktop'
};

export const screenSizeTrackingSlice = createAppSlice({
  name: 'screenSizeTracking',
  initialState,
  selectors: {
    getScreenWidth: (s) => s.width,
    getViewPort: (s) => s.viewPort
  },
  reducers: (create) => ({
    changeSize: create.reducer((state, action: PayloadAction<{ width: number; height: number }>) => {
      const { width, height } = action.payload;
      state.width = width;
      state.height = height;

      if (width > TABLET_BREAKPOINT) {
        state.viewPort = 'desktop';
      }

      if (width <= TABLET_BREAKPOINT && width >= MOBILE_BREAKPOINT) {
        state.viewPort = 'tablet';
      }

      if (width < MOBILE_BREAKPOINT) {
        state.viewPort = 'mobile';
      }
    })
  })
});

export const { changeSize } = screenSizeTrackingSlice.actions;

export const { getViewPort, getScreenWidth } = screenSizeTrackingSlice.selectors;

export const screenSizeTrackingReducer = screenSizeTrackingSlice.reducer;
